import {TableDefinition} from '~/backend/src/connectors/db/dbDefinition/DbDefinitionMapperUtilities';


const tableDefinition : TableDefinition = {
    table             : 'FILE',
    hasActiveView     : false,
    historyTablePrefix: 'H_',
    hasHistoryView    : false,
    hasView           : false,
    fieldMap          : {
        id              : 'FILE_ID',
        itemId          : 'FILE_CI_ID',
        data            : 'FILE_DATA',
        modifierUserId  : 'FILE_MODIFIER',
        modificationTime: 'FILE_MODIFICATION_TIME'
    },
    historyFieldMap   : {
        id            : 'FILE_ID',
        itemId        : 'FILE_CI_ID',
        data          : 'FILE_DATA',
        modifierUserId: 'FILE_MODIFIER',
        validFromTime : 'FILE_VALID_FROM',
        validToTime   : 'FILE_VALID_TO'
    },
    fieldTypesMap     : {
        id              : 'INTEGER',
        itemId          : 'INTEGER',
        data            : 'BYTEA',
        modifierUserId  : 'STRING',
        modificationTime: 'TIMESTAMP',
        validFromTime   : 'TIMESTAMP',
        validToTime     : 'TIMESTAMP'
    }
};

export default tableDefinition;
